import { render, staticRenderFns } from "./AdminClimateZoneForm.vue?vue&type=template&id=1f6f2eb1&"
import script from "./AdminClimateZoneForm.vue?vue&type=script&lang=js&"
export * from "./AdminClimateZoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports